// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { AggregatedTargetAttribute } from "./Reports.AggregatedTargetAttribute.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface ILocationUsageGrouping {
	periodStart: string;

	inCount: number;

	outCount: number;

	aggregatedAttribute: AggregatedTargetAttribute;

	aggregatedValue: number;

	$type?: string | undefined;
}
export class LocationUsageGrouping {
	constructor(data?: ILocationUsageGrouping) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.periodStart = new Date(data.periodStart);
	}

	@IsNotEmpty()
	periodStart: Date = new Date();

	inCount: number = 0;

	outCount: number = 0;

	aggregatedAttribute: AggregatedTargetAttribute = 0;

	aggregatedValue: number = 0;

	static $type: string = "CoreApi.Models.Reports.LocationUsageGrouping, ";
	$type?: string | undefined = LocationUsageGrouping.$type;
}

